import { useState, useEffect, useCallback, useRef } from 'react';

const SOC_SCREENS = [
  { label: 'CCTV', status: 'EN LIGNE' },
  { label: 'ALARMES', status: 'EN LIGNE' },
  { label: 'GPS', status: 'EN LIGNE' },
  { label: 'RADIO', status: 'EN LIGNE' },
  { label: 'CYBER', status: 'EN LIGNE' },
];

const PLACEHOLDER_ALERTS = [
  { id: 1, level: 'critical', time: '16:02', type: 'INTRUSION', desc: 'Intrusion detectee — Site Ecobank Tokoin' },
  { id: 2, level: 'warning', time: '15:45', type: 'RETARD', desc: 'Agent en retard — Poste Aeroport' },
  { id: 3, level: 'ok', time: '15:30', type: 'RONDE', desc: 'Ronde completee — Site Total Kegue' },
  { id: 4, level: 'critical', time: '15:12', type: 'ALARME', desc: 'Alarme declenchee — Entrepot Zone Portuaire' },
  { id: 5, level: 'warning', time: '14:58', type: 'EQUIPEMENT', desc: 'Radio hors service — Unite Mobile 3' },
  { id: 6, level: 'ok', time: '14:40', type: 'RELEVE', desc: 'Releve effectuee — Poste Ambassade FR' },
];

function useClock() {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  const pad = (n) => String(n).padStart(2, '0');
  const days = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'];
  const months = ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aout', 'Sep', 'Oct', 'Nov', 'Dec'];
  return {
    timeStr: `${pad(now.getUTCHours())}:${pad(now.getUTCMinutes())}:${pad(now.getUTCSeconds())}`,
    dateStr: `${days[now.getUTCDay()]}. ${pad(now.getUTCDate())} ${months[now.getUTCMonth()]} ${now.getUTCFullYear()}`,
  };
}

function useConnectionStatus(fetchFn, intervalMs = 30000) {
  const [connected, setConnected] = useState(true);
  const [lastUpdate, setLastUpdate] = useState(null);
  const [reconnected, setReconnected] = useState(false);
  const wasDisconnected = useRef(false);

  const wrappedFetch = useCallback(async () => {
    try {
      await fetchFn();
      if (wasDisconnected.current) {
        setReconnected(true);
        wasDisconnected.current = false;
        setTimeout(() => setReconnected(false), 3000);
      }
      setConnected(true);
      setLastUpdate(new Date());
    } catch {
      setConnected(false);
      wasDisconnected.current = true;
    }
  }, [fetchFn]);

  useEffect(() => { wrappedFetch(); }, [wrappedFetch]);
  useEffect(() => {
    const iv = setInterval(wrappedFetch, connected ? intervalMs : 5000);
    return () => clearInterval(iv);
  }, [wrappedFetch, intervalMs, connected]);

  const pad = (n) => String(n).padStart(2, '0');
  const lastTimeStr = lastUpdate ? `${pad(lastUpdate.getHours())}h${pad(lastUpdate.getMinutes())}` : '--:--';

  return { connected, reconnected, lastTimeStr };
}

export { useClock, useConnectionStatus, SOC_SCREENS, PLACEHOLDER_ALERTS };
